export default "__VITE_ASSET__CQ$WHoGK__"